export default {
  BAndRText: "Boeken & Recensies",
  Srchbook: "Zoek op boek",
  offlisugg: "Ofellio's suggesties ",
  recentlyRated: "Onlangs beoordeeld",

  // Reveiw Page
  rewbtn1: "Wil lezen",
  rewbtn2: "Schrijf een recensie",
  rewbtn3: "Gebruik voor Book Duo",
  rateBook: "Beoordeel dit boek",
  buyon: "Koop op",
  Read: "Lezen",
  reviewtext: "Recensie",
  ratingtext: "Jouw beoordeling",
  readon: "Lees op",
  book: "Boek",
  ebook: "E-book",
  audiobook: "Audioboek",
  revTitle: "Titel van de recensie",
  submitbtn: "Verzenden",

  // Book Duo Page
  yourbd: "Jouw Book Duo",
  serchbook: "Zoek boek",
  DidText: "Je boek niet gevonden? Voer details in!",
  city: "Stad",
  type: "Type",
  lookigfr: "Zoekend naar",
  male: "Man",
  female: "Vrouw",
  idk: "Maakt niet uit",
  agerg: "Leeftijdsgroep",
  language: "Taal",
  detil: "Details ",
  optnal: "Optioneel",
  lookiginsp: "Zoekend naar inspiratie",
  suggbokduo: "Voorgesteld boek voor een Book Duo",
  seemoresugg: "Bekijk meer suggesties",
  bokcvr: "Boekomslag ",
  title: "Titel",
  writer: "Schrijver ",
  genre: "Genre ",
  upload: "Uploaden ",
  add: "Toevoegen ",
  online: "Online",
  onlink: "Voeg link toe aan de videogesprek (Teams, Zoom, Google Meet etc)",
  noBookSelected: "Geen boek geselecteerd",
  loading: "Laden...",
  noResultsFound: "Geen resultaten gevonden",
  meetingLink: "Vergaderlink",
  noLimit: "Geen limiet",
  languageTooltip: "Dit is de taal die deelnemers zullen spreken tijdens Book Duo.",
  languageTooltipBookClub: "Dit is de taal die deelnemers zullen spreken tijdens Book Club.",
  updating: "Bijwerken...",
  publishing: "Publiceren...",
  update: "Bijwerken",
  noBooksFound: "Geen boeken gevonden onder deze suggestie voor een 1:1.",
  wellDone: "Goed gedaan!",
  bookDuoLive: "Je Book Duo is nu live.",
  willInformInterest: "We zullen je informeren wanneer iemand interesse toont!",
  seeOn: "Zie op",
  map: "Kaart",

  // Book Club Page
  when: "Wanneer",
  time: "Tijd ",
  age: "Leeftijd",
  publsbtn: "Publiceren ",
  day: "Dag",
  month: "Maand ",
  year: "Jaar",
  hour: "Uur",
  min: "Min",
  max: "Max",
  selectTime: "Selecteer tijd",
  selectLanguage: "Selecteer taal",
  selectType: "Selecteer type",
  inPerson: "Persoonlijk",
  attendees: "Deelnemers",
  eventDetails: "Evenementdetails",

  // Silent Reading Page
  where: "Waar",
  venue: "Locatie",
  address: "Adres",

  // BookAnd Review page Event
  welc: "Welkom",
  memb: "Lid",
  exploreText: "Verken en sluit je aan bij beschikbare evenementen en maak je eigen evenement.",
  sbybooks: "Boek ",
  month: "Maand ",
  sortby: "Sorteer op",
  cbduo: "Maak Book Duo",
  smoreevent: "Bekijk meer evenementen",
  dowant: "Wil je je eigen evenement maken?",
  ledAmbsdr: "Boekclubs en Stille Leessessies worden geleid door Ambassadors.",
  bAnAmbsdor: "Word Ambassador  ",
  leadText: "om er een te leiden of verken en sluit je aan bij",
  evtnear: "evenementen beschikbaar bij jou in de buurt.",
  BookDuoFirstText: `Zoek je een persoonlijke verbinding? Een Book Duo is perfect voor jou!`,
  BookDuoSecondText: `Zoek je een persoonlijke verbinding? Kies een boek, selecteer de leeftijd en geslacht voorkeur van een partner, en begin een één-op-één literaire reis.`,

  BookClubFirstText: `Ontdek boekenclubs persoonlijk in jouw omgeving of online, gehost in een gezellige setting zoals cafés, bars of een gastvrije locatie of via videoconferentie.`,
  BookClubSecondText: `Sluit je aan bij gastvrije persoonlijke of online boekenclubs gehost in gezellige settings. Elke groep wordt begeleid door een Ambassador om een levendige en inclusieve ervaring te garanderen.`,

  BookSilentFirstText: `Gehouden in een ontspannende en comfortabele setting, bieden Stille Leessessies een vredige ontsnapping voor maximaal 10 lezers.`,
  BookSilentSecondText: `Geniet van vredige stille leessessies. Neem je eigen boek mee, ontspan, en deel de stille vreugde van samen lezen.`,

  DuoBtnText: `Maak Book Duo`,
  ClubBtnText: `Maak Boekenclub`,
  SilentBtnText: `Maak Stille Leessessie`,
  bookDuoTitle: "Book Duo",
  bookClubTitle: "Boekenclub",
  bookSilentTitle: "Silent Reading",

  // BOOK_CLUB DUO SILENTREADING
  yownbook: "Je eigen boek",
  resetFilters: "Filters resetten",
  resetAll: "Alles resetten",
  applyFilters: "Filters toepassen",
  filters: "Filters",
  full: "VOL",
  booksCover: "Boekomslag",
  writerLabel: "Schrijver",
  genreLabel: "Genre",
  aboutTheBookLabel: "Over het boek",
  addButton: "Toevoegen",
  booked: "Geboekt",
  open: "Open",
  buyon: "Koop op",
  gender: "Geslacht",
  locatedin: "Gevestigd in",
  aboutbook: `Over het boek`,
  readmore: `Lees meer `,
  readless: `Lees minder `,
  details: "Details",
  totalspot: "Totaal plaatsen",
  spotleft: "Plaatsen over",
  join: "Deelnemen",
  share: "Delen",
  cregistration: "Voltooi je registratie",
  registrationmsg: "Je e-mailadres wordt gedeeld met de Ambassador ",
  welldone: "Goed gedaan!",
  attending: "Je neemt deel aan ",
  attendmsg:
    "Je kunt dit evenement nu zien in je Ofellio dashboard en chatten met je Ambassador",
  thankyou: "Bedankt!",
  thankmsg:
    "De organisator is nu op de hoogte van je interesse en kan je een bericht sturen om de details van dit Book Duo te regelen",
  // CHAT PAGE
  msgtext: "Berichten ",
  vprofile: "Dashboard",
  mute: "Dempen",
  block: "Blokkeren",
  unblock: "Deblokkeren",
  report: "Rapporteren",
  cancelR: "Annuleren",

  // Setting Page
  pprofile: "Persoonlijk Profiel",
  accnotifi: "Account Meldingen",
  uploadp: "Foto uploaden",
  name: "Naam",
  surname: "Achternaam",
  dob: "Geboortedatum",
  aboutme: "Over mij",
  country: "Land",
  favgenre: "Favoriete Genres",
  asmedia: "Voeg je sociale media hieronder toe",
  savechgbtn: "Wijzigingen opslaan",

  cypass: "Wijzig je wachtwoord",
  cypasstext:
    "Wanneer je je wachtwoord wijzigt, word je automatisch uitgelogd van je andere sessies",
  cpass: "Wijzig wachtwoord",
  cyemail: "Wijzig je e-mail",
  cyemailtext:
    "Wanneer je je e-mail wijzigt, word je automatisch uitgelogd van je andere sessies",
  cemail: "Wijzig e-mail",
  notifi: "Meldingen ",
  emailmeab: "E-mail me over",
  lastesttext: "Laatste trending boeken",
  upcomtext: "Nieuwe boeken van komende maand",
  baevent: "Boeken, Auteurs en evenementen die ik leuk zou vinden ",
  newoff: "Nieuwe Ofellio functies",
  leadin: "Ik leid",
  curnpass: "Huidig Wachtwoord",
  newpass: "Nieuw Wachtwoord",
  cnewpass: "Bevestig Nieuw Wachtwoord",
  curnemail: "Huidig e-mail",
  newemail: "Nieuw e-mail",
  cnewemail: "Bevestig Nieuw e-mail",
  delyacc: "Verwijder je account ",
  sorrytext: "Het spijt ons zeer dat je ons wilt verlaten!",
  suretext: "Weet je zeker dat je dit wilt doen? ",
  decitext:
    "Als je besluit Ofellio opnieuw te gebruiken, moet je een nieuw account aanmaken.",
  pass: "Wachtwoord",

  // meun
  jan: "Januari",
  feb: "Februari",
  mar: "Maart",
  apr: "April",
  may: "Mei",
  jun: "Juni",
  jul: "Juli",
  aug: "Augustus",
  sep: "September",
  oct: "Oktober",
  nov: "November",
  dec: "December",
  // Month abbreviations
  monthAbbrJan: "Jan",
  monthAbbrFeb: "Feb",
  monthAbbrMar: "Mrt",
  monthAbbrApr: "Apr",
  monthAbbrMay: "Mei",
  monthAbbrJun: "Jun",
  monthAbbrJul: "Jul",
  monthAbbrAug: "Aug",
  monthAbbrSep: "Sep",
  monthAbbrOct: "Okt",
  monthAbbrNov: "Nov",
  monthAbbrDec: "Dec",
  cri: "Misdaad",
  fic: "Fictie",
  grpnvl: "Graphic Novels & Manga",
  yng: "Young Adults & LGBTQ+",
  nonfic: "Non-fictie",
  scifan: "Sci-Fi & Fantasy",
  others: "Anderen",
  morerec: "Meest recent",
  lessrec: "Minst recent ",

  // HeaderProfil
  setg: "Instellingen ",
  logout: "Uitloggen",

  // dashbords pages
  editprf: "Profiel bewerken",
  cbduo: "Maak Book Duo",
  joining: "Ik neem deel",
  bandrew: "Boeken & Recensies ",

  upcomclub: "Aankomende Boekenclubs",
  upcomduo: "Aankomende Book Duos",
  upcomsil: "Aankomende Stille Leessessies",
  allpst: "Alle afgelopen evenementen ",
  edit: "Bewerken",
  canc: "RSVP Annuleren",
  going: "gaat",
  ngoing: "gaat niet ",
  cancel: "Annuleren",

  level: "Niveau",
  cbclub: "Maak Boekenclub",
  cbsil: "Maak Stille Leessessie ",
  loyprog: "Loyaliteitsprogramma",
  mang: "Beheren",
  attlist: "Deelnemerslijst",
  event: "RSVP Annuleren",

  chatgroup: "Chat met de groep",
  chatambas: "Chat met Ambassador",

  bookshelv: "Sally's Boekenkasten",
  reviews: "Recensies",

  // Leading Page
  ambassador: "Ambassador",
  member: "Lid",
  level1: "Niveau 1",
  level2: "Niveau 2",
  level3: "Niveau 3",
  level4: "Niveau 4",
  toLevel: "naar",
  highestLevel: "🎉 Je hebt het hoogste niveau bereikt!",
  editProfile: "Profiel bewerken",
  createBookClub: "Maak Boekenclub",
  createSilentReading: "Maak Stille Leessessie",
  createBookDuo: "Maak Book Duo",
  createEvent: "+ Maak Evenement",
  attendeesList: "Deelnemerslijst",
  edit: "Bewerken",
  cancel: "Annuleren",
  wantToRead: "Wil lezen",
  read: "Lezen",
  remove: "Verwijderen",
  tbd: "Nog te bepalen",
  full: "VOL",
  yourOwnBook: "Je eigen boek",
  ageLabel: "Leeftijd:",
  manage: "Beheren",
  cancelRSVP: "RSVP Annuleren",
  imLeading: "Ik leid",
  imJoining: "Ik neem deel",
  booksAndReviews: "Boeken & Recensies",
  loyaltyProgram: "Loyaliteitsprogramma",
  upcomingBookClubs: "Aankomende Boekenclubs",
  upcomingSilentReadings: "Aankomende Stille Leessessies",
  upcomingBookDuos: "Aankomende Book Duos",
  noEventsToShow: "Geen evenementen om te tonen.",
  wantToReadLower: "Wil lezen",
  readLower: "Lezen",
  reviewsLower: "Recensies",
  noRatedBooks: "Je hebt nog geen boeken beoordeeld.",
  giftsDiscounts: "Cadeaus en kortingen op lezen",
  loyaltyDescription: "Hoe meer je leest, hoe meer je wint! Geniet van kortingen en voordelen terwijl je niveau stijgt.",
  starterReader: "Starter Lezer",
  starterReaderDesc: "Begin je reis als Ofellio Ambassador en begin met het leiden van je eerste leeservaringen.",
  starterReaderReward: "Vroege erkenning en toegang tot toekomstige Ambassador voordelen.",
  communityBuilder: "Gemeenschapsbouwer",
  communityBuilderDesc: "Blijf lezers verbinden en boeiende boekevenementen creëren binnen je gemeenschap.",
  communityBuilderReward: "Prioritaire toegang tot nieuwe functies en exclusieve updates.",
  proHost: "Pro Host",
  proHostDesc: "Je vormt betekenisvolle leesmomenten en inspireert anderen door je evenementen.",
  proHostReward: "Uitnodigingen voor aankomende Ofellio initiatieven en speciale verrassingen.",
  legend: "Legende",
  legendDesc: "Blijf lezers wereldwijd inspireren — je leiderschap vormt de Ofellio gemeenschap.",
  legendReward: "Ontgrendel exclusieve erkenning en evoluerende voordelen.",
  attendees: "Deelnemers",
  noAttendeesYet: "Nog geen deelnemers.",
  chatWithGroup: "Chat met de groep",
  cancelEvent: "Evenement Annuleren",
  cancelRSVPConfirm: "Weet je zeker dat je je RSVP wilt annuleren?",
  cancelEventConfirm: "Weet je zeker dat je dit evenement wilt annuleren?",
  cancelRSVPEmail: "Een annulerings-e-mail wordt verzonden naar de Ambassador.",
  cancelEventEmail: "Een annulerings-e-mail wordt verzonden naar de huidige deelnemers.",

  // How It Works Section
  howOfellioWorks: "Hoe Ofellio werkt",
  howItWorksDesc: "Ontdek nieuwe manieren om via boeken te verbinden — één-op-één, in een groep, of in vredige stille leessessies.",
  bookDuoTitle: "Book Duo",
  bookDuoDesc: "Zoek je een persoonlijke verbinding? Kies een boek, selecteer de leeftijd en geslacht voorkeur van een partner, en begin een één-op-één literaire reis.",
  bookClubTitle: "Boekenclub",
  bookClubDesc: "Sluit je aan bij gastvrije persoonlijke of online boekenclubs gehost in gezellige settings. Elke groep wordt begeleid door een Ambassador om een levendige en inclusieve ervaring te garanderen.",
  silentReadingTitle: "Silent Reading",
  silentReadingDesc: "Geniet van vredige stille leessessies. Neem je eigen boek mee, ontspan, en deel de stille vreugde van samen lezen.",
  exploreThe: "Verken de",
  existingEvents: "bestaande evenementen",
  or: "of",
  createYourOwn: "maak je eigen",
  joinOfellio: "Sluit je aan bij Ofellio",
  signUp: "Aanmelden",
  chooseYourCountry: "Kies je land",
  joined: "deelgenomen",
  joinedCapitalized: "Deelgenomen",
  shareThisEvent: "Deel dit evenement",
  linkVisibleAttendees: "Link alleen zichtbaar voor deelnemers",
  recentReviews: "Recente recensies",
  noReviewsAvailable: "Geen recensies beschikbaar",
  writeAReview: "Schrijf een recensie",
  yourRating: "Jouw beoordeling",
  update: "Bijwerken",
  aboutTheBook: "Over het boek",
  makeAChoiceForThisBook: "Maak een keuze voor dit boek",
  howDidYouReadIt: "Hoe heb je het gelezen?",
  noRating: "Geen beoordeling",
  reviewPublished: "Recensie gepubliceerd",
  useForBookDuo: "Gebruik voor Book Duo",
  yourReview: "Jouw recensie",
  addAShortTitle: "Voeg een korte titel toe",
  shareYourThoughts: "Deel je gedachten over dit boek...",
  send: "Verzenden",
  bookclubLive: "Goed gedaan! Je Boekenclub is nu live en mensen kunnen zich aanmelden.",
  silentReadingLive: "Goed gedaan! Je Stille Lezen is nu live en mensen kunnen zich aanmelden.",
  dashboard: "Dashboard",
  
  // Day abbreviations
  dayMon: "Ma",
  dayTue: "Di",
  dayWed: "Wo",
  dayThu: "Do",
  dayFri: "Vr",
  daySat: "Za",
  daySun: "Zo",

  // Notification translations
  sentYouAMessage: "heeft je een bericht gestuurd!",
  justJoinedYour: "heeft zich zojuist aangemeld voor je",
};

